export default __webpack_public_path__ + "static/Fifth_Position_banner-f7e45eddf1c3d2258294e931f7151205.jpg";